import makeStyles from '@material-ui/core/styles/makeStyles'
import { DadosMurosSaida } from 'models/Viabilidade/DadosMurosSaida'
import { TipoProjetoEnum } from 'models/Viabilidade/Enum/TipoProjetoEnum'
import NumberFormat from 'react-number-format'
import * as S from './index.style'
import { ajudaMuroExterno } from 'helpers/Constantes/Mensagens'
import { FieldInfo } from 'components/FieldInfo'

const useStyles = makeStyles(() => ({
  label: {
    fontFamily: 'IBMPlexSans-Bold'
  }
}))

const Muro: React.FC<{ dados: DadosMurosSaida; tipoProjeto: string }> = ({ dados, tipoProjeto }) => {
  const classes = useStyles()

  return (
    <S.Wrapper>
      {tipoProjeto !== TipoProjetoEnum.LoteamentoAberto && (
        <>
          <S.GridMuro data-cy="gridMuroExterno">
            <S.NomeSubSessao data-cy="nomeSessaoMuroExterno">
              Muro Externo
              <FieldInfo title={ajudaMuroExterno} dataCy="fieldInfoMuroExterno" />
            </S.NomeSubSessao>
            <S.Campos>
              <S.Label data-cy="labelTipoMuroExterno" className={classes.label}>
                Tipo de Muro Externo
              </S.Label>
              <S.Valor color="secondary" data-cy="valorTipoMuroExterno">
                {dados?.tipoMuroExterno}
              </S.Valor>
            </S.Campos>
            <S.Campos>
              <S.Label data-cy="labelPerimetroExterno" className={classes.label}>
                Perímetro Externo (m)
              </S.Label>
              <S.Valor color="secondary" data-cy="valorPerimetroExterno">
                <NumberFormat
                  value={dados?.perimetroExterno}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                  fixedDecimalScale={true}
                  decimalScale={2}
                />
              </S.Valor>
            </S.Campos>
            <S.Campos>
              <S.Label data-cy="labelValorTotalExterno" className={classes.label}>
                Valor Total (R$/m²)
              </S.Label>
              <S.Valor color="secondary" data-cy="valorTotalExterno">
                <NumberFormat
                  value={dados?.valorTotalMuroExterno}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                />
              </S.Valor>
            </S.Campos>
          </S.GridMuro>
        </>
      )}
      <S.GridMuro>
        <S.NomeSubSessao>Muro Interno</S.NomeSubSessao>
        <S.Campos>
          <S.Label data-cy="labelTipoMuroInterno" className={classes.label}>
            Tipo de Muro Interno
          </S.Label>
          <S.Valor color="secondary" data-cy="valorTipoMuroInterno">
            {dados?.tipoMuroInterno}
          </S.Valor>
        </S.Campos>
        <S.Campos>
          <S.Label data-cy="labelValorTotalInterno" className={classes.label}>
            Valor Total (R$/m²)
          </S.Label>
          <S.Valor color="secondary" data-cy="valorTotalInterno">
            <NumberFormat
              value={dados?.valorTotalMuroInterno}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            />
          </S.Valor>
        </S.Campos>
      </S.GridMuro>
    </S.Wrapper>
  )
}

export default Muro
